export const ourValueAndApproachSubMenu = [
  {
    id: 1,
    link: "#integrity",
    label: "Integrity",
  },
  {
    id: 2,
    link: "#partnership",
    label: "Partnership",
  },
  {
    id: 3,
    link: "#excellence",
    label: "Excellence",
  },
];
